var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollapse = function SvgCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M5.584 10.898c0-.23.187-.416.417-.416h3.891l-.944-.945-2.586-2.586a.417.417 0 0 1 .59-.589l2.585 2.586.947.947V5.999a.417.417 0 0 1 .833 0v4.9c0 .23-.187.416-.417.416H6a.417.417 0 0 1-.416-.417Zm8.524 2.62H17.9a.417.417 0 1 0 0-.833H13a.417.417 0 0 0-.416.417v4.9a.417.417 0 0 0 .833 0v-3.995l.703.702 3.085 3.086a.417.417 0 1 0 .59-.59l-3.086-3.085-.601-.602Z",
    clipRule: "evenodd"
  })));
};
export default SvgCollapse;